import React from 'react';

import { Container } from './styles';

const NoRegisterFound = () => {
  return <Container>Nenhum registro encontrado</Container>;
};

export default NoRegisterFound;
